import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { SEGMENT as BASE_SEGMENT } from '@root/app-routing.model';
import { AuthService } from '@core/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(
		private readonly router: Router,
		private readonly authService: AuthService
	) {}

	canActivate(): boolean {
		const token: string | null = this.authService.getToken();
		let shouldActivate: boolean = false;
		if (token) {
			shouldActivate = true;
		} else {
			this.router.navigate([`/${BASE_SEGMENT.CONNECT}`]);
		}
		return shouldActivate;
	}
}
